import { useState, useEffect } from 'react';
import {useDispatch, useSelector} from "react-redux";
import { supabase, useUpdateUserMutation, useUserQuery } from './api'
import { Button, Flex, FormControl, FormLabel, Heading, Input, Select, Stack, useColorModeValue,
} from '@chakra-ui/react'
import { PasswordInput } from '../components/password_input.jsx'
import {path} from 'ramda';
import { Formik, Form,Field } from 'formik';

export default function Account({session}) {
  const dispatch = useDispatch();
  const texts = useSelector(path(["ui","ui_texts"]));
  const {data:user} = useUserQuery(session?.user?.id);
  const [updateUser] = useUpdateUserMutation();

  const handleSubmit = async (values, { setSubmitting }) => {
    setSubmitting(true);
    updateUser({
      id: session.user.id,
      firstname: values.firstname,
      lastname: values.lastname,
      email: values.email,
      lang: values.lang,
      updated_at: new Date(),
    });
    setSubmitting(false);
  }

  return (
    <Flex minH={'100vh'} align={'center'} justify={'center'} bg={useColorModeValue('gray.50', 'gray.800')}>
      <Stack spacing={4} w={'full'} maxW={'md'} bg={useColorModeValue('white', 'gray.700')} 
        rounded={'xl'} boxShadow={'lg'} p={6} my={12}>
        <Heading lineHeight={1.1} fontSize={{ base: '2xl', sm: '3xl' }}>{texts.profile_info}</Heading>
      <Formik enableReinitialize={true} initialValues={user} onSubmit={handleSubmit}>
        {({ values, handleSubmit, isSubmitting }) => (
          <Form onSubmit={handleSubmit}>
            <FormControl id="firstname" isRequired>
              <FormLabel>{texts.firstname}</FormLabel>
              <Field as={Input} name="firstname" isRequired/>
            </FormControl>
            <FormControl id="lastname" isRequired>
              <FormLabel>{texts.lastname}</FormLabel>
              <Field as={Input} name="lastname" isRequired/>
            </FormControl>
            <FormControl id="email" isRequired>
              <FormLabel>email</FormLabel>
              <Field as={Input} name="email" isRequired/>
            </FormControl>
            <Field name="lang">
              {({ field }) => (
                <FormControl>
                  <FormLabel>{texts.language}</FormLabel>
                  <Select {...field} placeholder={texts.select}>
                    <option value="et">Eesti</option>
                    <option value="en">English</option>
                  </Select>
                </FormControl>
              )}
            </Field>

            <Button
                mt={4}
                colorScheme="teal"
                w="full"
                size="md"
                type="submit"
                isLoading={isSubmitting}
              >
                {texts.save}
              </Button>
          </Form>
        )}
      </Formik>
      </Stack>
    </Flex>
  )
}